import { ApplicationStatus, Gender, StreetType } from "../interfaces/enums";
import { ApplicationWithId } from "../interfaces/IApplications";
import { AppUser } from "../interfaces/IUsers";
import { ContestWithId } from "../interfaces/IContests";

export const getNewApplication = (contest: ContestWithId, user: AppUser) => {
  if (contest && user) {
    const application: ApplicationWithId = {
      id: "",
      contestId: contest.id as string,
      contestName: contest?.name as string,
      createTimestamp: new Date(),
      participantPresentationsMap: {},
      sendTimestamp: null,
      status: ApplicationStatus.DRAFT,
      totalCost: 0,
      userFirstName: user?.firstName as string,
      userId: user?.id as string,
      userLastName: user?.lastName as string,
      userOrganizationName: user?.organizationName as string,
      isInvoiceNeeded: false,
      invoiceData: emptyInvoiceData,
    };
    return application;
  }
};

export const getNewPresentation = () => {
  return emptyPresentationWithId;
};

export const emptyInvoiceData = {
  city: "",
  houseNumber: "",
  localNumber: "",
  name: "",
  postalCode: "",
  street: "",
  streetType: StreetType.STREET,
  taxId: "",
};

export const emptyUserWithId = {
  consents: [],
  email: "",
  firstName: "",
  id: "",
  invoiceData: {
    city: "",
    houseNumber: "",
    localNumber: "",
    name: "",
    postalCode: "",
    street: "",
    streetType: StreetType.STREET,
    taxId: "",
  },
  isActive: true,
  isFirstLogin: true,
  isInvoiceNeeded: false,
  lastName: "",
  organizationName: "",
  phoneNumber: "",
};

export const emptyParticipant = {
  birthDate: new Date(),
  firstName: "",
  gender: Gender.FEMALE,
  isActive: true,
  lastName: "",
  userId: "",
};

export const emptyParticipantWithId = {
  birthDate: new Date(),
  firstName: "",
  gender: Gender.FEMALE,
  id: "",
  isActive: true,
  lastName: "",
  userId: "",
};

export const emptyPresentation = {
  applicationId: "",
  categoryId: "",
  contestId: "",
  name: "",
  participants: [],
  startNo: 0,
  title: "",
  userId: "",
};

export const emptyPresentationWithId = {
  applicationId: "",
  categoryId: "",
  contestId: "",
  id: "",
  name: "",
  participants: [],
  startNo: 0,
  title: "",
  userId: "",
};
